import React from 'react';
import Layout from '../components/Layout';
import './About.css';
import Profile from '../components/Profile';

const About: React.FC = () => {
  return (
    <Layout>
      <section className="about-section">
        <Profile
          name="渡邊 磨王斗"
          description="栃木県出身。大学院修士1年。自然言語処理とWeb技術に関心があります。"
        />
        <div className="bio">
          <h3>経歴</h3>
          <ul>
            <li>静岡大学 情報学部 行動情報学科（2021〜2025）</li>
            <li>静岡大学大学院 総合科学技術研究科 情報学専攻（2025〜）</li>
          </ul>
          <h3>趣味</h3>
          <p>スポーツ観戦（野球、サッカー、バスケットボール）、お笑い芸人の様々な動画を見ること</p>
        </div>
      </section>
    </Layout>
  );
};

export default About;



  